const income = [
    {
      id: "1",
      name: "25 Lac+"
    },
    {
      id: "2",
      name: "15 Lac to 24.9Lac"
    },
    {
      id: "3",
      name: "10 Lac to 14.9Lac"
    },
    {
      id: "4",
      name: "8 Lac to 9.9Lac"
    },
    {
      id: "5",
      name: "5 Lac to 7.9Lac"
    },
    {
      id: "6",
      name: "3 Lac to 4.9Lac"
    },
    {
      id: "7",
      name: "2 Lac to 2.9Lac"
    },
    {
      id: "8",
      name: "Less than 2Lac"
    }
  ]

  export default income;